import type { ComponentType } from 'react'
import type { QuestV2 } from './types'

export interface QuestCardOverrideProps {
  quest: QuestV2
  onClaimed?: () => void
}

/**
 * Per-buttonAction **full card replacement**.
 *
 * The default `QuestCardV2` layout (icon + title + rewards + progress +
 * action button + dot) handles ~95% of quest types and can be partially
 * tuned via `useQuestCardViewModel` (rewards / status / className overrides).
 * For action types whose UI diverges enough that the default layout is the
 * wrong shape, register a full replacement component here — `QuestCardV2`
 * short-circuits to it before any default rendering happens.
 *
 * Registered components own the entire card: theming, the red dot, the
 * `viewRef` IntersectionObserver, the click flow, accessibility text — all
 * of it. Prefer a `useQuestCardViewModel` override whenever the default
 * layout can be coerced into the desired shape; reach for the registry only
 * when the structural shape itself needs to change.
 *
 * The keys are `quest.buttonAction` literal values (typed as `string` so the
 * registry can hold future action types not yet known at compile time).
 */
export const questCardOverrideRegistry: Partial<
  Record<string, ComponentType<QuestCardOverrideProps>>
> = {}
